import { switchChain } from 'wagmi/actions';
import { config } from '../../config/wagmi';
import { mainnet, goerli } from 'wagmi/chains';

// Type-safe chain IDs based on your wagmi config
type SupportedChainId = typeof mainnet.id | typeof goerli.id;

export const changeNetwork = async (chainId: SupportedChainId): Promise<void> => {
  try {
    await switchChain(config, { chainId });
  } catch (error) {
    console.error('Failed to switch network:', error);
    // Fallback to direct ethereum request
    (window as any).ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: `0x${chainId.toString(16)}` }],
    });
  }
};
